export default "__VITE_ASSET__15817d55__"